import { AuthActiveUserDTO } from '@haohan/papi-dto';
import React from 'react';

export const AppStoreContext = React.createContext({
    activeUser: null as AuthActiveUserDTO,
    refetchUser: () => void {},
});

export const useAppCtx = () => {
    const ctx = React.useContext(AppStoreContext);
    return ctx;
}
